export default __webpack_public_path__ + "static/media/JFActingResume.7a8e7927.png";